import WithBookstoreService from './with-bookstore-service'

export default WithBookstoreService